import { SignUpEventCard } from "@oc-labs/wt-storybook";
import { useNavigate } from "react-router-dom";
import useModal from "../../../../hooks/useModal";

export default function RWAMenu() {
    const { open } = useModal('rwa-type-selector');

  const navigate = useNavigate();

  const assets = [
    {
        title: "Create assets",
        content: "Add your products and experience cards here",
        iconName: "plus",
        selected: true,
        onClick: () => open()
    },
    {
        title: "Wine Bottles",
        content: "Full overview of wine bottles",
        iconName: "shopping_cart",
        selected: false,
        onClick: () => navigate('/dashboard/rwa/type/WineBottle')
    },
    {
        title: "Experience cards",
        content: "Full overview of all experience cards",
        iconName: "shopping_cart",
        selected: false,
        onClick: () => navigate('/dashboard/rwa/type/ExperienceCard')
    },
    {
        title: "Products",
        content: "Full overview of products",
        iconName: "shopping_cart",
        selected: false,
        onClick: () => navigate('/dashboard/rwa/type/Product')
    },
    {
        title: "Zai Products",
        content: "Full overview of Zai products",
        iconName: "shopping_cart",
        selected: false,
        onClick: () => navigate('/dashboard/rwa/type/ZaiProduct')
    },
  ];
  return (<div className="col-span-1 xl:col-span-12 grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-4 gap-4 mb-8">
    {assets.map((asset, index) => (
        <SignUpEventCard
            key={index}
            title={asset.title}
            content={asset.content}
            iconName={asset.iconName}
            selected={asset.selected}
            onClick={asset.onClick}
        />
    ))}
  </div>)
}